import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import ImageComparison from '../components/ImageComparison';
import ContentDisplay from '../components/ContentDisplay';

const BeautifyPage = ({ variant = 'light' }) => {
  const { t } = useTranslation();
  const isDark = variant === 'dark';
  
  const tabData = {
    id: 'beautify',
    label: t('navigation.beautify'),
    title: t('pages.beautify.title'),
    subtitle: t('pages.beautify.subtitle')
  };

  return (
    <motion.div
      className="container mx-auto px-4 py-6 lg:py-10"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.6 }}
    >
      {/* 文字说明区域 */}
      <div className="mb-8 lg:mb-12">
        <ContentDisplay activeTab="beautify" tabData={[tabData]} variant={variant} />
      </div>

      {/* 图片对比区域 */}
      <div className="mb-8 lg:mb-12">
        <div className="max-w-7xl mx-auto">
          {/* 大屏幕：并排显示 */}
          <div className="hidden xl:block">
            <div className="grid grid-cols-2 gap-12">
              {/* Meica 对比块 */}
              <div className="space-y-6">
                <motion.h3
                  className={`text-xl font-semibold text-center mb-6 ${isDark ? 'text-white' : 'text-slate-900'}`}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.5, ease: "easeOut" }}
                >
                  {t('pages.beautify.meica_title')}
                </motion.h3>
                <ImageComparison
                  beforeImage="/2_before.jpeg"
                  afterImage="/2_after.jpg"
                  className="w-full"
                  initialAspectRatio={1080 / 733}
                  maxWidthPx={600}
                  maxWidthPxMd={700}
                  minWidthPx={320}
                  maxHeightVh={60}
                  mediumScreenMaxHeightVh={62}
                  smallScreenMaxHeightVh={54}
                />
              </div>

              {/* 美图秀秀对比块 */}
              <div className="space-y-6">
                <motion.h3
                  className={`text-xl font-semibold text-center mb-6 ${isDark ? 'text-slate-300' : 'text-slate-500'}`}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.7, ease: "easeOut" }}
                >
                  {t('pages.beautify.competitor_title')}
                </motion.h3>
                <ImageComparison
                  beforeImage="/2_before.jpeg"
                  afterImage="/2_after_meitu.jpg"
                  className="w-full"
                  initialAspectRatio={1080 / 733}
                  maxWidthPx={600}
                  maxWidthPxMd={700}
                  minWidthPx={320}
                  maxHeightVh={60}
                  mediumScreenMaxHeightVh={62}
                  smallScreenMaxHeightVh={54}
                />
              </div>
            </div>
          </div>

          {/* 中小屏幕：上下排列 */}
          <div className="xl:hidden space-y-12">
            {/* Meica 对比块 */}
            <div className="space-y-5 max-w-4xl mx-auto">
              <motion.h3
                className={`text-2xl font-semibold text-center mb-6 ${isDark ? 'text-white' : 'text-slate-900'}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.5, ease: "easeOut" }}
              >
                {t('pages.beautify.meica_title')}
              </motion.h3>
              <ImageComparison
                beforeImage="/2_before.jpeg"
                afterImage="/2_after.jpg"
                className="w-full"
                initialAspectRatio={1080 / 733}
                maxWidthPx={840}
                maxWidthPxMd={720}
                minWidthPx={320}
                maxHeightVh={66}
                mediumScreenMaxHeightVh={62}
                smallScreenMaxHeightVh={54}
              />
            </div>

            {/* 美图秀秀对比块 */}
            <div className="space-y-5 max-w-4xl mx-auto">
              <motion.h3
                className={`text-2xl font-semibold text-center mb-6 ${isDark ? 'text-slate-300' : 'text-slate-500'}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.7, ease: "easeOut" }}
              >
                {t('pages.beautify.competitor_title')}
              </motion.h3>
              <ImageComparison
                beforeImage="/2_before.jpeg"
                afterImage="/2_after_meitu.jpg"
                className="w-full"
                initialAspectRatio={1080 / 733}
                maxWidthPx={840}
                maxWidthPxMd={720}
                minWidthPx={320}
                maxHeightVh={66}
                mediumScreenMaxHeightVh={62}
                smallScreenMaxHeightVh={54}
              />
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default BeautifyPage;